'use client';

import React from 'react';
import { UserPlusIcon } from '@heroicons/react/24/outline';
import { useTranslations } from 'use-intl';
import { classnames } from '@/utils/classnames/classnames';
import type { RegisterTradeAccountButtonProps } from './types';

// Presentational only — no auth context. The guest-gating + drawer wiring
// lives in the RegisterTradeAccountTrigger container so this stays trivially
// storyable and testable.
const VARIANT_CLASSES: Record<RegisterTradeAccountButtonProps['variant'], string> = {
  // Full-height red segment on the right of the desktop secondary nav (matches v0).
  desktop:
    'ml-auto flex h-full items-center gap-2 bg-red-600 px-6 font-semibold text-white transition-colors hover:bg-red-700',
  // Full-width block button inside the mobile nav drawer.
  mobile:
    'flex w-full items-center justify-center gap-2 rounded-md bg-red-600 px-4 py-3 font-semibold text-white transition-colors hover:bg-red-700',
};

const RegisterTradeAccountButton = ({
  variant,
  controlsId,
  isOpen,
  onClick,
  className = '',
}: RegisterTradeAccountButtonProps) => {
  const translate = useTranslations();

  return (
    <button
      type="button"
      onClick={onClick}
      aria-haspopup="dialog"
      aria-controls={controlsId}
      aria-expanded={isOpen}
      className={classnames('text-14', VARIANT_CLASSES[variant], className)}
    >
      <UserPlusIcon className="size-5" aria-hidden />
      <span>{translate('auth.register-trade-account')}</span>
    </button>
  );
};

export default RegisterTradeAccountButton;
